define("SuiteDB.SDBProductMapPairs", [
  "SuiteDB.SDBProductMapPairs.View",
], function (SDBProductMapPairsView) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      /** @type {LayoutComponent} */
      var layout = container.getComponent("Layout");

      if (layout) {
        layout.addChildView("Product.Details.Table", function () {
          return new SDBProductMapPairsView({ container: container });
        });
      }
    },
  };
});
